/**
 * One drop of today as it stands (user, 20/10/2026: "the Live … like a
 * professional"): sent, sending, scheduled in SMSWiser, staged, held by
 * auto-send, left for a person (20/10/2026 — the Belgium test: a draft
 * auto-send released after an unknown outcome read "held by auto-send"),
 * decided in shadow, stopped by a verdict, skipped by hand, due and not
 * sent, waiting, or not generated yet. Pure — the strip, its legend and the
 * totals read the same answer.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DayPlanDropRow } from '../../../drop-generator.types';

export type DropState =
  | 'sent'
  | 'sending'
  | 'scheduled'
  | 'staged'
  | 'held'
  /** Auto-send gave it up — missed by over 30 min or released after an unknown outcome — a person sends it. */
  | 'left'
  | 'shadow'
  | 'stopped'
  | 'skipped'
  | 'overdue'
  | 'waiting'
  | 'planned';

export function dropState(drop: DayPlanDropRow, now: Date): DropState {
  const r = drop.runtime;
  if (!r) return 'planned';
  if (r.tombstoned) return r.skipReason?.startsWith('stopped') ? 'stopped' : 'skipped';
  if (r.sentAt) return 'sent';
  if (r.sending) return 'sending';
  if (r.shadowAt) return 'shadow';
  if (r.remoteScheduledAt) return 'scheduled';
  if (r.staged) return 'staged';
  if (r.autoSendNote) return /left for a person/.test(r.autoSendNote) ? 'left' : 'held';
  return new Date(drop.atUtc).getTime() < now.getTime() ? 'overdue' : 'waiting';
}

/** The words for a state (legend, tooltips). */
export const STATE_WORDS: Record<DropState, string> = {
  sent: 'sent',
  sending: 'sending now',
  scheduled: 'scheduled in SMSWiser',
  staged: 'staged in SMSWiser',
  held: 'held by auto-send',
  left: 'left for you to send',
  shadow: 'shadow — would have sent',
  stopped: 'stopped by a verdict',
  skipped: 'skipped by hand',
  overdue: 'due — not sent yet',
  waiting: 'waiting for its time',
  planned: 'planned — not generated yet',
};

/** Still to go today: a drop that can still be sent. */
export const isOpen = (s: DropState): boolean => s === 'waiting' || s === 'overdue' || s === 'held' || s === 'left' || s === 'staged' || s === 'scheduled' || s === 'sending' || s === 'planned';
